import React, { useState } from 'react';
import clsx from 'clsx';
import { CircularProgress, Collapse, Typography, Link, Button } from 'ui-kit';
import OnboardingModuleSteps from './OnboardingModuleISteps/OnboadingModuleSteps';
import './OnboardingModule.scss';
import useOnboardingSteps, { OnboardingStep } from 'hooks/useOnboardingSteps';
import NewProductModal from 'components/Dashboard/Store/NewProductModal';
import ShareModal from 'components/Dashboard/Share/ShareModal';
import { NewProductMode } from 'components/NewProductStepper/NewProductStepper';

export default function OnboardingModule({ storeId }: { storeId: number }) {
  const [addProduct, setAddProduct] = useState(false);
  const [shareStore, setShareStore] = useState(false);

  const [newProductMode, setNewProductMode] = useState<NewProductMode>('default');

  const toogleAddProductModal = () => setAddProduct((prev) => !prev);
  const toogleShareModal = () => setShareStore((prev) => !prev);

  const openProductModal = (mode: NewProductMode) => {
    setNewProductMode(mode);
    setAddProduct(true);
  };

  const {
    isCompleted,
    completedSteps,
    steps,
    activeStep,
    initialCollapseStatus,
    handleCollapseStatus,
    toggleStepComplete,
  } = useOnboardingSteps({
    storeId,
    actions: {
      [OnboardingStep.firstProduct]: () => {
        openProductModal('quick');
      },
      [OnboardingStep.shareStore]: () => {
        toogleShareModal();
      },
    },
  });

  if (isCompleted) {
    return null;
  }

  return (
    <div className="OnboardingModule-container">
      <Collapse
        initialCollpase={initialCollapseStatus}
        onCollapse={handleCollapseStatus}
        header={(isCollapse) => (
          <div className="OnboardingModule-collapsable-header">
            <Typography
              variant="h5"
              className={clsx('OnboardingModule-collapsable-header__title', {
                'OnboardingModule-collapsable-header__title-collapsed': isCollapse,
              })}
            >
              {!isCollapse ? (
                'Start selling checklist'
              ) : (
                <>
                  {activeStep.id === OnboardingStep.shareStore ? 'Last step: ' : 'Next step: '}
                  <Button
                    variant="text"
                    color="primary"
                    onClick={(e) => {
                      e.stopPropagation();
                      activeStep.action?.(activeStep.id);
                    }}
                  >
                    {activeStep.title}
                  </Button>
                </>
              )}
            </Typography>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <CircularProgress steps={steps.length} completedSteps={completedSteps.length} />
            </div>
          </div>
        )}
      >
        <div className="OnboardingModule-collapsable-content">
          <Typography variant="body2">
            For more information watch <Link href="#">our video library</Link>
          </Typography>

          <OnboardingModuleSteps
            steps={steps}
            completedSteps={completedSteps}
            activeStep={activeStep}
            onStepAction={activeStep.action}
            onStepToggleComplete={toggleStepComplete}
          />
        </div>
      </Collapse>
      <NewProductModal
        storeId={storeId}
        isOpen={addProduct}
        onCancel={toogleAddProductModal}
        mode={newProductMode}
      />
      <ShareModal isOpen={shareStore} onClose={toogleShareModal} storeId={storeId} />
    </div>
  );
}
